import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { useTenant } from '../../../../contexts/TenantContext';
import { usePreviewHeader } from '../hooks';
import { formatTimestamp } from '../utils';

const PreviewHeader: React.FC = () => {
  const { isAddEditHost } = useTenant();
  const { modificationTimestamp } = usePreviewHeader();
  const savedOn = formatTimestamp(modificationTimestamp);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2, md: 4 },
        py: 2,
        gap: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '@media print': { py: 1 },
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
      }}
    >
      {/* Left: Logo (Bright only) */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: {
            xs: 1,
            md: 'auto',
          },
        }}
      >
        {!isAddEditHost() && (
          <img src="/bright/logo.svg" alt="Bright MLS" style={{ height: 48 }} />
        )}
      </Box>

      {/* Right: Title + timestamp + print */}
      <Box
        sx={{
          // textAlign: 'right',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 0.5,
          width: {
            xs: 1,
            md: 'auto',
          },
        }}
      >
        <Stack
          sx={{
            gap: 2,
            flexDirection: {
              xs: 'row-reverse',
              md: 'row',
            },
            justifyContent: 'space-between',
            width: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              startIcon={<PrintOutlinedIcon />}
              onClick={() => window.print()}
              sx={{
                color: 'text.primary',
                borderColor: 'divider',
                '@media print': { display: 'none' },
                '& .MuiButton-startIcon': {
                  mr: {
                    xs: 0,
                    md: 1,
                  },
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  display: {
                    xs: 'none',
                    md: 'inline-block',
                  },
                }}
              >
                Print
              </Box>
            </Button>
          </Box>
          <Box
            sx={{
              textAlign: 'left',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 0.5,
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, color: 'text.primary' }}
            >
              Draft Listing Preview
            </Typography>
            {savedOn && (
              <Typography variant="caption" color="text.secondary">
                Last saved on: {savedOn}
              </Typography>
            )}
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default React.memo(PreviewHeader);
